import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type DeclineOfferRequestDialogProps = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    confirmDisabled?: boolean;
};

// Confirmation step for declining an offer request before the partner has made contact.
export function DeclineOfferRequestDialog({
    open,
    onConfirm,
    onCancel,
    confirmDisabled = false,
}: DeclineOfferRequestDialogProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="decline-request-dialog-title"
            aria-describedby="decline-request-dialog-description">
            <DialogTitle id="decline-request-dialog-title">
                {t('OFFER_REQUESTS.DETAIL.DECLINE_DIALOG.TITLE')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="decline-request-dialog-description">
                    {t('OFFER_REQUESTS.DETAIL.DECLINE_DIALOG.BODY')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{t('OFFER_REQUESTS.DETAIL.DECLINE_DIALOG.CANCEL')}</Button>
                <Button variant="contained" color="error" onClick={onConfirm} disabled={confirmDisabled}>
                    {t('OFFER_REQUESTS.DETAIL.DECLINE_DIALOG.CONFIRM')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
